import styled, { css } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { styles } from '../constants/styles.js';
import { spacing } from '../constants/spacing.js';
import { boxStyles } from '../Box/styles.js';
import { fontFamilyStyles } from '../ContentText/styles.web.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';
import { lineHeights } from '../constants/line-heights.js';

var row = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__row",
  componentId: "sc-gamgno-0"
})(["", "{display:table-row;}"], styles.breakpoint.m);
var title = /*#__PURE__*/styled.dt.withConfig({
  displayName: "styles__title",
  componentId: "sc-gamgno-1"
})(["color:", ";font-size:", ";line-height:", ";", "{padding-right:", ";display:table-cell;white-space:nowrap;}"], function (props) {
  return props.theme.descriptionList.web.label.color;
}, function (props) {
  return px2rem(props.theme.descriptionList.web.label.fontSize);
}, lineHeights.tight, styles.breakpoint.m, spacing.s);
var description = /*#__PURE__*/styled.dd.withConfig({
  displayName: "styles__description",
  componentId: "sc-gamgno-2"
})(["margin:0;color:", ";font-size:", ";font-weight:", ";line-height:", ";", "{padding-left:", ";display:table-cell;}"], function (props) {
  return props.theme.descriptionList.web.description.color;
}, function (props) {
  return px2rem(props.theme.descriptionList.web.description.fontSize);
}, function (props) {
  return props.theme.descriptionList.web.description.fontWeight;
}, lineHeights.tight, styles.breakpoint.m, spacing.s);
var list = /*#__PURE__*/styled.dl.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__list",
  componentId: "sc-gamgno-3"
})(["", ";width:100%;", "{padding-bottom:", ";padding-top:", ";padding-left:", ";}", "{padding-bottom:", ";padding-top:0;padding-right:", ";padding-left:", ";text-align:left;}", "{border-collapse:collapse;display:table;", "{padding-top:", ";text-align:", ";}}", " ", ";"], fontFamilyStyles, title, function (props) {
  return props.$size === 'condensed' ? px2rem(12) : spacing.xxs;
}, function (props) {
  return props.$size === 'condensed' ? px2rem(13) : px2rem(17);
}, function (props) {
  return props.$indent ? spacing.s : 0;
}, description, function (props) {
  return props.$size === 'condensed' ? px2rem(12) : spacing.xxs;
}, function (props) {
  return props.$indent ? spacing.s : 0;
}, function (props) {
  return props.$indent ? spacing.s : 0;
}, styles.breakpoint.m, description, function (props) {
  return props.$size === 'condensed' ? px2rem(13) : px2rem(17);
}, function (props) {
  return props.$alignDescription === 'right' ? 'right' : 'left';
}, function (props) {
  return props.$divided && css(["", "{border-bottom:", " solid ", ";&:last-child{border-bottom:0;}}"], row, px2rem(2), props.theme.descriptionList.web.dividerColor);
}, boxStyles);

export { description, list, row, title };
